import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { faAngleDoubleLeft, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import { LensConfigMode } from "src/app/model/configuration/configuration";
import { NewOrderStoreService } from "src/app/new-order/new-order-store-service.service";
import { ReturnStoreService } from "src/app/return/return-store.service";

@Component({
    selector: 'app-copy-switch-button',
    templateUrl: './copy-switch-button.component.html',
    styleUrls: ['./copy-switch-button.component.scss']
})
export class CopySwitchButtonComponent implements OnInit {

    url: string;

    lensConfigMode: LensConfigMode;
    LensConfigMode = LensConfigMode;

    arrowRight = faAngleDoubleRight;
    arrowLeft = faAngleDoubleLeft;

    @Input() side: string;

    @Output() copyEmit = new EventEmitter<string>();
    @Output() switchEmit = new EventEmitter<string>();

    constructor(private newOrderStoreService: NewOrderStoreService,
                private router: Router,
                private returnStoreService: ReturnStoreService){
    }

    ngOnInit(): void {
        this.url = this.router.url;
        if(this.url === '/return') {
            this.lensConfigMode = this.returnStoreService.getLensConfigMode();
        } else if(this.url.includes('/new-order')) {
            this.lensConfigMode = this.newOrderStoreService.getLensConfigMode();
            this.newOrderStoreService.lensConfigMode$.subscribe(data => {
                this.lensConfigMode = data;
            });
        }
    }

    copy() {
        this.copyEmit.emit(this.side);
    }

    switch() {
        this.switchEmit.emit(this.side);
    }
}